import React from 'react'
import createReactClass from 'create-react-class'
import MgStatsFooter from './mg/mgstatsfooter'

const StatsFooter = createReactClass({
	render() {
		const { cancel, migrate } = this.props
		switch (migrate.get('origin')) {
		case ORIGIN.FLYWHEEL:
		case ORIGIN.CLOUDWAYS:
		case ORIGIN.WPENGINE:
		case ORIGIN.AUTOMATTIC:
			return null
		default:
			return <MgStatsFooter cancel={cancel}/>
		}
	}
})

export default StatsFooter
